/** Email único de contacto y administración de Ratafit (visible en la app). */
export const RATAFIT_CONTACT_EMAIL = 'info@ratafit.com';
